import gql from "graphql-tag";

// ----------
// Mutations

export const CREATE_PATIENT_NOTE = gql`
  mutation CreatePatientNote($patientID: UUID!, $note: String!) {
    createPatientNote(patientID: $patientID, note: $note) {
      note
      createdAt
      emrUser {
        id
        firstName
        lastName
      }
    }
  }
`;

export const CREATE_PATIENT_DOCTOR_MESSAGE = gql`
  mutation CreatePatientDoctorMessage($message: String!) {
    createPatientDoctorMessage(message: $message) {
      id
      message
      readAt
      status
      createdAt
      emrUserFirstName
      emrUserLastName
      emrUserIsDoctor
    }
  }
`;

export const CREATE_PATIENT_READ_RECEIPT_ON_LATEST_MESSAGE_FROM_DOCTOR = gql`
  mutation CreatePatientReadReceiptOnLatestMessageFromDoctor {
    createPatientReadReceiptOnLatestMessageFromDoctor {
      doctorPatientMessageID
      createdAt
    }
  }
`;

export const CREATE_PATIENT_CARE_MESSAGE = gql`
  mutation CreatePatientCareMessage($message: String!) {
    createPatientCareMessage(message: $message) {
      id
      message
      readAt
      status
      createdAt
      emrUserFirstName
      emrUserLastName
    }
  }
`;

export const CREATE_PATIENT_READ_RECEIPT_ON_LATEST_PATIENT_CARE_MESSAGE = gql`
  mutation CreatePatientReadReceiptOnLatestPatientCareMessage {
    createPatientReadReceiptOnLatestPatientCareMessage {
      messageID
      createdAt
    }
  }
`;

// ----------
// Queries
export const GET_DOCTOR_PATIENT_MESSAGES = gql`
  query {
    doctorPatientMessages {
      id
      message
      readAt
      status
      createdAt
      emrUserFirstName
      emrUserLastName
      emrUserIsDoctor
    }
  }
`;

export const GET_PATIENT_CARE_MESSAGES = gql`
  query {
    patientCareMessages {
      id
      message
      readAt
      status
      createdAt
      emrUserFirstName
      emrUserLastName
    }
  }
`;

// ----------
// Queries
// export const GET_PATIENT_PRESCRIPTIONS = gql`
//   query {
//     patientPrescriptions {
//       id
//       visitID
//       refills
//       quantity
//       numRefillsFilled
//       patientDirections
//     }
//   }
// `;

export const GET_PATIENT_RECORD = gql`
  query {
    patientRecord {
      patient {
        id
        firstName
        lastName
        birthday
        gender
        usState
        profession
        email
        phone
        affiliateToken
        lockedUntil
        sleepConciergeBookedAt
        personaVerified
      }
      visits {
        id
        visitType
        visitDate
        patientCompletedAt
        orderNumber
        status
        address1
        address2
        city
        usState
        zip
        orderType
        pharmacyInfo
        stripeInvoiceURL
        stripeReceiptURL
        visitPrescriptions {
          id
          medicationName
          medicationDosage
          medicationFormFactor
          visitID
          quantity
          refills
          numRefillsFilled
          patientDirections
          fillPharmacyID
          dosespotPharmacyID
          ncpdpPharmacyID
          createdAt
          orderItemID
          refillsCanceled
        }
        visitOrderPayments {
          id
          isRefill
          stripeReceiptURL
        }
        orderItems {
          id
          consultationType
          productSlug
          subcategory
          isAddon
        }
        createdAt
        personaHostedURL
      }
      doctorPatientMessagesCount
      hasCompletedMeeting
      upcomingMeeting {
        id
        calcomBookingUID
        meetingType
        status
        startsAt
        endsAt
        location
        videoCallURL
        hostName
      }
      subscriptions {
        id
        orderType
        status
        subType
        prescriptions {
          id
          medicationName
          medicationDosage
          medicationFormFactor
          quantity
          refills
          numRefillsFilled
          patientDirections
          fillPharmacyID
          dosespotPharmacyID
          ncpdpPharmacyID
          createdAt
          autoshipStatus
          autoshipMostRecentFillRequestID
          autoshipLastShipDate
          autoshipNextShipDate
        }
        fillRequests {
          status
          trackingURL
          createdAt
          completedAt
          doctorPrescription1ID
          doctorPrescription2ID
          doctorPrescription3ID
          doctorPrescription4ID
        }
        latestVisit {
          id
          address1
          address2
          city
          usState
          zip
          orderType
          visitType
          status
          pharmacyInfo
        }
        cancelAt
        canceledAt
      }
    }
  }
`;
